/**
 * What the browser is allowed to render, and what it is only allowed to download.
 *
 * The preview used to run every downloaded file through @cyntler/react-doc-viewer,
 * whose text renderer carries GHSA-fvhg-p4hf-79x3 (XSS, no fix available). A .txt
 * from a customer document feed was therefore rendered as markup. Keep this an
 * allowlist: an unknown extension previews nothing and downloads as a binary blob.
 * (Sovellon #2260, finding F-03.)
 */

const PREVIEWABLE = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};

const DOWNLOAD_ONLY = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  doc: 'application/msword',
  csv: 'text/csv',
  txt: 'text/plain',
  zip: 'application/zip',
};

const FALLBACK_MIME = 'application/octet-stream';

export const getExtension = (fileName) =>
  String(fileName || '').split('.').pop().toLowerCase();

/** MIME type to hand the Blob, so the download keeps the right file type. */
export const getMimeType = (fileName) => {
  const ext = getExtension(fileName);
  return PREVIEWABLE[ext] || DOWNLOAD_ONLY[ext] || FALLBACK_MIME;
};

/** True only for the types we are willing to render in the browser. */
export const isPreviewable = (fileName) =>
  Object.prototype.hasOwnProperty.call(PREVIEWABLE, getExtension(fileName));

export const isImage = (fileName) =>
  (PREVIEWABLE[getExtension(fileName)] || '').startsWith('image/');

export const isPdf = (fileName) => getExtension(fileName) === 'pdf';

export default PREVIEWABLE;
